/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Numbers_AgentsInputs */

const en_about_numbers_agents = /** @type {(inputs: About_Numbers_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`19 AI Agents`)
};

const de_about_numbers_agents = /** @type {(inputs: About_Numbers_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`19 KI-Agenten`)
};

const fr_about_numbers_agents = /** @type {(inputs: About_Numbers_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`19 AI Agents`)
};

const es_about_numbers_agents = /** @type {(inputs: About_Numbers_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`19 AI Agents`)
};

const it_about_numbers_agents = /** @type {(inputs: About_Numbers_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`19 AI Agents`)
};

const nl_about_numbers_agents = /** @type {(inputs: About_Numbers_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`19 AI Agents`)
};

const pl_about_numbers_agents = /** @type {(inputs: About_Numbers_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`19 AI Agents`)
};

const fi_about_numbers_agents = /** @type {(inputs: About_Numbers_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`19 AI Agents`)
};

const da_about_numbers_agents = /** @type {(inputs: About_Numbers_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`19 AI Agents`)
};

const sv_about_numbers_agents = /** @type {(inputs: About_Numbers_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`19 AI Agents`)
};

/**
* | output |
* | --- |
* | "19 AI Agents" |
*
* @param {About_Numbers_AgentsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_numbers_agents = /** @type {((inputs?: About_Numbers_AgentsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Numbers_AgentsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_numbers_agents(inputs)
	if (locale === "fr") return fr_about_numbers_agents(inputs)
	if (locale === "es") return es_about_numbers_agents(inputs)
	if (locale === "it") return it_about_numbers_agents(inputs)
	if (locale === "nl") return nl_about_numbers_agents(inputs)
	if (locale === "pl") return pl_about_numbers_agents(inputs)
	if (locale === "fi") return fi_about_numbers_agents(inputs)
	if (locale === "da") return da_about_numbers_agents(inputs)
	if (locale === "sv") return sv_about_numbers_agents(inputs)
	return en_about_numbers_agents(inputs)
});